/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import Tile from './Tile';
import { ContentfulApiClient } from '../../../lib/99dodContentfulClient';
import styled from 'styled-components';
import Bugsnag from '@bugsnag/js';

export default function TileGrid() {
    const [tiles, setTiles] = useState<any>([]);
    // count only tiles with link and image or video for tile indexes.
    const numberedTiles = tiles
        ? tiles.filter((tile: any) => tile.link && (tile.image || tile.video))
        : [];
    const matrix = [1, 1, 1, 1, 2, 1, 2, 1, 1];

    useEffect(() => {
        (async () => {
            const tileData = await ContentfulApiClient.requestTileData();
            if (tileData.length <= 0) {
                Bugsnag.notify(
                    new Error('No tile data returned from Contentful for 99daysofdesign')
                );
            }
            setTiles(tileData);
        })();
    }, []);

    return (
        <TileGridContainer>
            {tiles.map((tile: any, i: number) => (
                <Tile
                    key={i}
                    index={numberedTiles.findIndex((nt: any) => nt.title === tile.title)}
                    displayIndex={
                        numberedTiles.find((nt: any) => nt === tile)
                            ? 99 -
                              numberedTiles.length +
                              numberedTiles.findIndex((nt: any) => nt === tile) +
                              1
                            : null
                    }
                    image={tile.image}
                    video={tile.video}
                    title={tile.title}
                    text={tile.text}
                    author={tile.author}
                    business={tile.business}
                    color={typeof tile.color === 'string' ? tile.color : null}
                    link={tile.link}
                    designedBy={tile.designedBy}
                    designedByLink={tile.designedByLink}
                    designedByColor={tile.designedByColor}
                    category={tile.category && tile.category.name}
                    logo={tile.logo && tile.logo.logo}
                    red={tile.color && tile.color[0] === 'red'}
                    white={tile.color && tile.color[0] === 'white'}
                    large={matrix[i % matrix.length] === 2}
                    betweenLarge={
                        matrix[i % matrix.length] === 1 &&
                        matrix[(i % matrix.length) - 1] === 2 &&
                        matrix[(i % matrix.length) + 1] === 2
                    }
                />
            ))}
        </TileGridContainer>
    );
}

const TileGridContainer = styled.div`
    &::after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: ' ';
        clear: both;
        height: 0;
    }
`;
